import { CircularProgress } from "@mui/material"

const Loader = ({ style }) => {
  return (
    <div
      col={1}
      style={{ alignSelf: "center", width: "100%", height: "100%", ...style }}
      sf="mc"
    >
      <CircularProgress />
    </div>
  )
}

export default Loader
